// extracted by mini-css-extract-plugin
export default {"header":"BM-z","isActive":"CM-z"};